import React from 'react';

const SmallExclamationCircle = props => {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' {...props}>
            <path
                fill='#F55A5A'
                fillRule='evenodd'
                d='M7.308 9.066L7.092 4.17h1.816l-.24 4.9-1.36-.004zM8 11.892c-.502 0-.908-.406-.908-.909 0-.5.406-.907.908-.907s.908.407.908.907c0 .503-.406.91-.908.91zM8 0C3.582 0 0 3.582 0 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8z'
            />
        </svg>
    );
};

export default SmallExclamationCircle;
